export default "__VITE_ASSET__1afa752c__"